// B2B Signup Page - AIAgentify Voyager
import { useState } from 'react';
import { useNavigate, Navigate, Link } from 'react-router-dom';
import { useB2B } from '../context/B2BContext';

export default function B2BSignup() {
  const navigate = useNavigate();
  const { signup, isAuthenticated, loading } = useB2B();
  
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    ownerName: '',
    agencyName: '',
    website: ''
  });
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  if (!loading && isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  const handleChange = (e) => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    
    try {
      await signup(formData);
      navigate('/');
    } catch (err) {
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="b2b-login-page">
      <div className="b2b-login-container">
        <div className="b2b-login-left">
          {/* Voyager Logo */}
          <div style={{ marginBottom: '24px' }}>
            <img 
              src="/voyager-logo-white.svg" 
              alt="AIAgentify Voyager" 
              style={{ height: '120px' }}
            />
          </div>
          
          <h1>Start Your Free Trial</h1>
          <p>Get AI-powered travel assistance on your website in under 5 minutes.</p>
          
          <div className="b2b-login-features">
            <div className="b2b-login-feature">
              <span className="icon">✅</span>
              14-day free trial
            </div>
            <div className="b2b-login-feature">
              <span className="icon">💳</span>
              No credit card required
            </div>
            <div className="b2b-login-feature">
              <span className="icon">🚀</span>
              Setup in 5 minutes
            </div>
            <div className="b2b-login-feature">
              <span className="icon">📞</span>
              Cancel anytime
            </div>
          </div>
        </div>
        
        <div className="b2b-login-right">
          <div className="b2b-login-header">
            <div className="b2b-login-logo">Voyager</div>
            <div className="b2b-login-subtitle">Create Your Account</div>
          </div>
          
          <form className="b2b-login-form" onSubmit={handleSubmit}>
            {error && <div className="b2b-login-error">{error}</div>}
            
            <div className="b2b-form-group">
              <label className="b2b-form-label">Your Name</label>
              <input
                type="text"
                name="ownerName"
                className="b2b-form-input"
                placeholder="John Smith"
                value={formData.ownerName}
                onChange={handleChange}
                required
              />
            </div>
            
            <div className="b2b-form-group">
              <label className="b2b-form-label">Agency Name</label>
              <input
                type="text"
                name="agencyName"
                className="b2b-form-input"
                placeholder="Smith Family Travel"
                value={formData.agencyName}
                onChange={handleChange}
                required
              />
            </div>
            
            <div className="b2b-form-group">
              <label className="b2b-form-label">Email</label>
              <input
                type="email"
                name="email"
                className="b2b-form-input"
                placeholder="you@agency.com"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
            
            <div className="b2b-form-group">
              <label className="b2b-form-label">Password</label>
              <input
                type="password"
                name="password"
                className="b2b-form-input"
                placeholder="Min 8 characters"
                value={formData.password}
                onChange={handleChange}
                minLength={8}
                required
              />
            </div>
            
            <div className="b2b-form-group">
              <label className="b2b-form-label">Website (optional)</label>
              <input
                type="url"
                name="website"
                className="b2b-form-input"
                placeholder="https://youragency.com"
                value={formData.website}
                onChange={handleChange}
              />
            </div>
            
            <button type="submit" className="b2b-login-btn" disabled={submitting}>
              {submitting ? 'Creating account...' : 'Start Free Trial'}
            </button>
            
            <div className="b2b-login-footer" style={{ marginTop: '20px' }}>
              Already have an account? <Link to="/login">Sign in</Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
